// Modal
export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";

// Auth
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const CURRENT_USER = "CURRENT_USER";
export const REGISTER_USER = "REGISTER_USER";
export const RECOVER_USER = "RECOVER_USER";
export const LOADING_REFRESH_TOKEN = "LOADING_REFRESH_TOKEN";
export const SHOW_DIALOG_USER_IDDLE = "SHOW_DIALOG_USER_IDDLE";
export const AUTHENTICATION_V2_USER = "AUTHENTICATION_V2_USER";
export const CURRENT_AUTHENTICATION_V2_USER = "CURRENT_AUTHENTICATION_V2_USER";

// sessions
export const LOAD_SESSIONS = "LOAD_SESSIONS";
export const LOADING_SESSIONS = "LOADING_SESSIONS";
export const LOADING_CLOSE_SESSION = "LOADING_CLOSE_SESSION";
export const LOADING_CLOSE_ALL_SESSIONS = "LOADING_CLOSE_ALL_SESSIONS";

// creditos
export const LOAD_CREDITOS = "LOAD_CREDITOS";
export const LOAD_CREDITO = "LOAD_CREDITO";
export const LOADING_CREDITOS = "LOADING_CREDITOS";
export const LOADING_CREDITO = "LOADING_CREDITO";
export const LOAD_CUOTAS = "LOAD_CUOTAS";
export const LOADING_CUOTAS = "LOADING_CUOTAS";

// pagos
export const LOADING_PROCESAR_PAGO = "LOADING_PROCESAR_PAGO";
export const LOADING_CALCULAR_ITF = "LOADING_CALCULAR_ITF";
export const LOADING_DISPONIBILIDAD_PAGO = "LOADING_DISPONIBILIDAD_PAGO";
export const DISPONIBILIDAD_PAGO = "DISPONIBILIDAD_PAGO";
export const MSG_ERROR_SERVICIO_NO_DISPONIBLE =
  "MSG_ERROR_SERVICIO_NO_DISPONIBLE";
export const VALIDACION_PROGRAMA_ESTADO = "VALIDACION_PROGRAMA_ESTADO";
export const LOADING_VALIDAR_PROGRAMA_ESTADO =
  "LOADING_VALIDAR_PROGRAMA_ESTADO";

// campanias
export const LOAD_CAMPANIAS = "LOAD_CAMPANIAS";
export const LOADING_CAMPANIAS = "LOADING_CAMPANIAS";
export const LOADING_NOTIFICACION_SECTORISTA =
  "LOADING_NOTIFICACION_SECTORISTA";

// cuentas
export const LOAD_CUENTAS = "LOAD_CUENTAS";
export const LOAD_CUENTA = "LOAD_CUENTA";
export const LOADING_CUENTAS = "LOADING_CUENTAS";
export const LOADING_CUENTA = "LOADING_CUENTA";
export const LOAD_MOVIMIENTOS = "LOAD_MOVIMIENTOS";
export const LOADING_MOVIMIENTOS = "LOADING_MOVIMIENTOS";
export const LOADING_APERTURAR_CUENTA_AHORROS_VALIDAR =
  "LOADING_APERTURAR_CUENTA_AHORROS_VALIDAR";
export const LOADING_APERTURAR_CUENTA_AHORROS_CONFIRMAR =
  "LOADING_APERTURAR_CUENTA_AHORROS_CONFIRMAR";
export const LOADING_APERTURAR_CUENTA_DPF_VALIDAR =
  "LOADING_APERTURAR_CUENTA_DPF_VALIDAR";
export const LOADING_APERTURAR_CUENTA_DPF_CONFIRMAR =
  "LOADING_APERTURAR_CUENTA_DPF_CONFIRMAR";
export const LOAD_CUENTAS_OPERACIONES = "LOAD_CUENTAS_OPERACIONES";
export const LOADING_CUENTAS_OPERACIONES = "LOADING_CUENTAS_OPERACIONES";
export const LOAD_CUENTAS_OPERACIONES_PRYMERA =
  "LOAD_CUENTAS_OPERACIONES_PRYMERA";
export const LOADING_CUENTAS_OPERACIONES_PRYMERA =
  "LOADING_CUENTAS_OPERACIONES_PRYMERA";
export const LOAD_CUENTAS_DEPOSITO = "LOAD_CUENTAS_DEPOSITO";
export const LOADING_CUENTAS_DEPOSITO = "LOADING_CUENTAS_DEPOSITO";
export const LOAD_PRODUCTOS_CUENTA_APERTURA = "LOAD_PRODUCTOS_CUENTA_APERTURA";
export const LOADING_PRODUCTOS_CUENTA_APERTURA = "LOADING_PRODUCTOS_CUENTA_APERTURA";

// afiliacion
export const LOAD_CLAVE_DOBLE_FACTOR_USUARIO = "LOAD_CLAVE_DOBLE_FACTOR_USUARIO";
export const LOADING_CLAVE_DOBLE_FACTOR_USUARIO = "LOADING_CLAVE_DOBLE_FACTOR_USUARIO";
export const LOADING_GENERAR_CLAVE_DOBLE_FACTOR = "LOADING_GENERAR_CLAVE_SMS";
export const LOADING_VALIDAR_CLAVE_DOBLE_FACTOR = "LOADING_VALIDAR_CLAVE_SMS";

//transferencias
export const LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_VALIDAR =
  "LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_VALIDAR";
export const LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_CONFIRMAR =
  "LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_CONFIRMAR";
export const LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_VALIDAR =
  "LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_VALIDAR";
export const LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_CONFIRMAR =
  "LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_CONFIRMAR";
export const LOADING_TRANSFERENCIA_CUENTAS_IFIS_VALIDAR =
  "LOADING_TRANSFERENCIA_CUENTAS_IFIS_VALIDAR";
export const LOADING_TRANSFERENCIA_CUENTAS_IFIS_CONFIRMAR =
  "LOADING_TRANSFERENCIA_CUENTAS_IFIS_CONFIRMAR";
export const LOAD_BANCOS_TRANSFERENCIA = "LOAD_BANCOS_TRANSFERENCIA";
export const LOADING_BANCOS_TRANSFERENCIA = "LOADING_BANCOS_TRANSFERENCIA";
